import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24f6cf10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opening-wrapper" }
const _hoisted_2 = { class: "register-help" }
const _hoisted_3 = {
  class: "border-bottom",
  style: {"padding-bottom":"24px"}
}
const _hoisted_4 = { class: "ris-wrapper" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ris-content" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" 1、注资申请: "),
    /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"5px"} }, [
      /*#__PURE__*/_createTextVNode("完成基本账户开⽴以后，请申请集团注资，完成以下信息填写，待财务总监-⽩晓卓审批后，"),
      /*#__PURE__*/_createElementVNode("br")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"90px"} }, "财务部会在RNSS系统提交申请⾛审批，通过后即可注资10万元⾄新开业公司基本户。")
  ]),
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"5px"} }, "2、正式开业时间提交")
], -1))
const _hoisted_7 = { style: {"margin-top":"24px"} }
const _hoisted_8 = {
  key: 0,
  class: "form-wrapper"
}
const _hoisted_9 = { style: {"padding":"24px","padding-bottom":"60px"} }
const _hoisted_10 = { class: "content-wrapper" }
const _hoisted_11 = {
  key: 2,
  class: "flow-box"
}

import {
  onMounted,
  ref,
  computed,
  withDefaults,
  watch,
  createVNode,
  watchEffect,
} from "vue";
import { OPENLIST } from "@/const/home";
import HeadTitle from "@/components/HeadTitle.vue";
import Approval from "@/components/Approval.vue";
import ButtonGroup from "@/components/ButtonGroup.vue";
import { add, detail, draw } from "@/api/process_open";
import Detail from "./detail.vue";
import { message, Modal } from "ant-design-vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";

import type { FormInstance } from "ant-design-vue";
import { useStore } from "vuex";
import { FileType, NodeItem } from "@/types/procss";
import { useRoute } from "vue-router";
import { approve } from "@/api/openapply";
import { GetCurrentMyPageList } from "@/api/index";


export default /*#__PURE__*/_defineComponent({
  props: {
    flowData: { default: () => [] }
  },
  emits: ["update-flow"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { flowData: NodeItem[] }

const fileList: { title: string; type: FileType; link: string }[] = [
  {
    title: "财务部门税务及银行开户等注意事项",
    type: FileType.PDF,
    link: "https://static2.risfond.com//hrsop/StaffContract/2023/202305/20230504/20230504_110358665535378_6434.pdf",
  },
];
const actionButtons = ref<(string | number)[]>([]); //默认是申请审批
const preButton = ref<(string | number)[]>([]); //存储重新发起点击前按钮
const reEdit = ref<boolean>(false); //是否点击重新发起标识
const edit = computed(() => actionButtons.value.includes("100"));

const store = useStore();
const personInfo = computed(() => store.getters.getSimpleInfo);
const route = useRoute();
const { query } = route;
const id = ref(query.id || "");
const WorkFlowId = ref<number>(0);

const currentData = ref<NodeItem>();
const preData = ref<NodeItem>();
const BranchCompanyFlowId = ref<number>(0);


watch(
  () => props.flowData,
  (val) => {
    if (!val) return;
    const { id, type } = route.query;
    if (id && type) {
      //从列表也进入
      currentData.value = val.find((item: NodeItem) => item.Code == type);
      BranchCompanyFlowId.value = currentData.value.BranchCompanyFlowId;
      if (!currentData.value.IsOperation) {
        preData.value = {
          Title: "所有模块的必填项",
        };
      }
    } else {
      //从流程节点页面进入
      let _parent_data = val.find((item: NodeItem) => item.Code == "8");
      BranchCompanyFlowId.value = _parent_data.BranchCompanyFlowId;
      currentData.value = _parent_data;
      if (!_parent_data.IsOperation) {
        preData.value = {
          Title: "所有模块的必填项",
        };
      }
    }
    detailInfo();
  }
);

watchEffect(() => {
  const { id } = route.query;
  if (id) {
    if (!actionButtons.value.includes("90")) {
      actionButtons.value.unshift("90");
    }
  }
});


const formRef1 = ref<FormInstance>(); //选址表单
const visible = ref<boolean>(false);
const rejectedVisible = ref<boolean>(false);
const applyOnOkVisible = ref<boolean>(false);
const refresh = ref<boolean>(false);

const tableData = [
  {
    depart: "财务管理中心",
    name: "张馨予",
    duty: "财务支持全模",
    email: "Zhangxinyu@risfond.com",
    phone: "15010170908",
  },
  {
    depart: "总经办",
    name: "纪银红",
    duty: "全流程咨询",
    email: "Jan.Ji@risfond.com",
    phone: "18810273871",
  },
];
const form = ref({
  Id: 0,
  CompanyName: "",
  ContactPhone: "",
  TaxNo: "",
  BankAccount: "",
  Address: "",
  OpenAccountBank: "",
  GrandOpenTime: "",
});
const list = ["提交银行开户申请", "提交税务报道申请", "提交银行开户备案资料"];

const handleClick = async (buttonType: string | number) => {
  if (buttonType == "100") {
    submit1();
  } else if (buttonType == "102") {
    preButton.value = actionButtons.value;
    actionButtons.value = ["-1", "-2"];
    reEdit.value = true;
  } else if (buttonType == "101") {
    visible.value = true;
  } else if (buttonType == "104") {
    //驳回
    rejectedVisible.value = true;
  } else if (buttonType == "103") {
    //通过
    applyOnOkVisible.value = true;
    // Modal.confirm({
    //   content: "您确认要通过审核吗？",
    //   icon: createVNode(ExclamationCircleOutlined),
    //   onOk() {
    //     pass();
    //   },
    //   style: {
    //     top: "30%",
    //   },
    //   cancelText: "取消",
    //   onCancel() {
    //     Modal.destroyAll();
    //   },
    // });
  } else if (buttonType == "-1") {
    reEdit.value = false;
    detailInfo();
    //节点
  } else if (buttonType == "-2") {
    submit1();
  }
};

const detailInfo = async () => {
  let params = { Id: BranchCompanyFlowId.value };
  if (!BranchCompanyFlowId.value && route.query.staffId) {
    params.StaffId = Number(route.query.staffId);
  }
  const { Data } = await detail(params);
  form.value = Data;
  actionButtons.value = Data?.ActionButtons || [];
  WorkFlowId.value = Data?.WorkFlowId || 0;
};

const submit1 = () => {
  formRef1.value?.validateFields().then(async (res) => {
    //提交申请
    const { Success, Message } = await add({
      Id: BranchCompanyFlowId.value,
      CompanyName: form.value.CompanyName,
      ContactPhone: form.value.ContactPhone,
      TaxNo: form.value.TaxNo,
      BankAccount: form.value.BankAccount,
      Address: form.value.Address,
      OpenAccountBank: form.value.OpenAccountBank,
      GrandOpenTime: form.value.GrandOpenTime,
    });
    if (Success) {
      message.success("已提交审核");
      $emit("update-flow");
      reEdit.value = false;
    } else {
      message.error(Message || "提交失败，请稍后重试");
    }
  });
};
const handleRejectback = () => {
  rejectedVisible.value = false;
  refresh.value = !refresh.value;
  $emit("update-flow");
  getList();
};
const handleApplyOnOk = () => {
  applyOnOkVisible.value = !applyOnOkVisible.value;
  refresh.value = !refresh.value;
  $emit("update-flow");
  getList();
};
//通过审核
const pass = async () => {
  const { Success } = await approve({
    Description: "",
    WorkflowId: WorkFlowId.value,
    Status: 1, //1:通过 2: 驳回
  });
  if (Success) {
    message.success("提交成功");
    $emit("update-flow");
    refresh.value = !refresh.value;
    getList();
  } else {
    message.success("提交失败");
  }
  Modal.destroyAll();
};
const getList = async () => {
  const { Success, Data } = await GetCurrentMyPageList();

  if (Success) {
    store.commit("setWaitList", Data.ApproveCount);
    store.commit("setToList", Data.ToCCCount);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_RecallBack = _resolveComponent("RecallBack")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_Reject = _resolveComponent("Reject")!
  const _component_ApplyOnOK = _resolveComponent("ApplyOnOK")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(HeadTitle, { title: "正式开业及注资申请注意事项" }),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: require('@/assets/imgs/Book/flower_rui.png')
            }, null, 8, _hoisted_5),
            _hoisted_6
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(HeadTitle, { title: "流程对接部门及名单" })
        ]),
        _createVNode(_component_a_table, {
          pagination: false,
          dataSource: tableData,
          columns: _unref(OPENLIST)
        }, null, 8, ["columns"])
      ]),
      (
        (_unref(personInfo).IsCreate == 1 || (id.value && _unref(personInfo).IsCreate == 0)) &&
        currentData.value &&
        currentData.value.IsDataAccess == 1
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(HeadTitle, { title: "正式开业及注资审批事项" }),
              _createVNode(_component_RecallBack, {
                id: BranchCompanyFlowId.value,
                show: visible.value,
                onClose: _cache[0] || (_cache[0] = ($event: any) => {
            visible.value = false;
            detailInfo();
          })
              }, null, 8, ["id", "show"]),
              _createElementVNode("div", _hoisted_10, [
                (
              (id.value && _unref(personInfo).IsCreate == 0 && !form.value.CompanyName) ||
              WorkFlowId.value == 0 ||
              reEdit.value
            )
                  ? (_openBlock(), _createBlock(_component_a_form, {
                      key: 0,
                      class: _normalizeClass(["open-form-wrapper", 
              currentData.value && currentData.value.State > 1 && !reEdit.value
                ? 'border-bottom'
                : ''
            ]),
                      layout: "inline",
                      "label-col": { style: { width: '110px' } },
                      labelAlign: "left",
                      model: form.value,
                      ref_key: "formRef1",
                      ref: formRef1
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: "公司名称",
                          class: "open-form-item",
                          name: "CompanyName",
                          required: "",
                          colon: false,
                          rules: [
                {
                  max: 50,
                },
              ]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: form.value.CompanyName,
                              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.CompanyName) = $event)),
                              placeholder: "请输入"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          label: "联系电话",
                          class: "open-form-item",
                          name: "ContactPhone",
                          required: "",
                          colon: false,
                          rules: [
                {
                  max: 50,
                },
              ]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: form.value.ContactPhone,
                              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.ContactPhone) = $event)),
                              placeholder: "请输入"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          label: "开户银行",
                          class: "open-form-item",
                          name: "OpenAccountBank",
                          required: "",
                          colon: false,
                          rules: [
                {
                  max: 50,
                },
              ]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: form.value.OpenAccountBank,
                              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.value.OpenAccountBank) = $event)),
                              placeholder: "请输入"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          label: "银行账户号码",
                          class: "open-form-item",
                          name: "BankAccount",
                          required: "",
                          colon: false,
                          rules: [
                {
                  max: 50,
                },
              ]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: form.value.BankAccount,
                              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.value.BankAccount) = $event)),
                              placeholder: "请输入"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          label: "税号",
                          class: "open-form-item",
                          name: "TaxNo",
                          required: "",
                          colon: false,
                          rules: [
                {
                  max: 50,
                },
              ]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: form.value.TaxNo,
                              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((form.value.TaxNo) = $event)),
                              placeholder: "请输入"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          label: "正式开业时间",
                          class: "open-form-item",
                          name: "GrandOpenTime",
                          required: "",
                          disabled: "",
                          colon: false,
                          rules: [
                {
                  max: 50,
                },
              ]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_date_picker, {
                              value: form.value.GrandOpenTime,
                              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((form.value.GrandOpenTime) = $event)),
                              style: {"width":"292px"},
                              valueFormat: "YYYY-MM-DD",
                              placeholder: "请选择",
                              showToday: true
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          label: "地址",
                          rules: [
                {
                  max: 50,
                },
              ],
                          name: "Address",
                          required: "",
                          colon: false
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              style: {"width":"751px"},
                              value: form.value.Address,
                              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((form.value.Address) = $event)),
                              placeholder: "请输入"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["class", "model"]))
                  : (_openBlock(), _createBlock(Detail, {
                      key: 1,
                      detail: form.value
                    }, null, 8, ["detail"])),
                (currentData.value && currentData.value.State > 1 && !reEdit.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(HeadTitle, {
                        title: '审批流程',
                        class: "flow-box-headtitle"
                      }),
                      _createVNode(Approval, {
                        id: WorkFlowId.value,
                        refresh: refresh.value
                      }, null, 8, ["id", "refresh"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (actionButtons.value.length > 0)
      ? (_openBlock(), _createBlock(ButtonGroup, {
          key: 0,
          "type-list": actionButtons.value,
          onClick: handleClick,
          "show-tips": 
      preData.value && preData.value.Title
        ? `提示：完成${preData.value.Title}审批后方可申请该模块`
        : ''
    
        }, null, 8, ["type-list", "show-tips"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Reject, {
      id: WorkFlowId.value,
      show: rejectedVisible.value,
      onClose: handleRejectback
    }, null, 8, ["id", "show"]),
    _createVNode(_component_ApplyOnOK, {
      id: WorkFlowId.value,
      show: applyOnOkVisible.value,
      onClose: handleApplyOnOk
    }, null, 8, ["id", "show"])
  ], 64))
}
}

})